import SafeAreaContainer from "../components/safe-area-container";
import Paragraph from "../components/paragraph";
import { Button, Grid, Image } from "@mantine/core";
import { ExternalLink } from "tabler-icons-react";

import {useStyles} from "../styles"
import { useTranslation } from "react-i18next";

import link from "../images/link.jpg"
import zug from "../images/zug.jpg"
import zentrum from "../images/zentrum.png"
import hoenggerberg from "../images/hoenggerberg.png"

export default function MobilitaetPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div>
        <SafeAreaContainer>
          <div className={classes.container}>
            
            <h1 className={classes.title}>{t("MobilitaetPage.title")}</h1>

            <div className={classes.content}>

              <h2>{t("MobilitaetPage.campustitle")}</h2>

              <Grid grow gutter="lg" justify="space-around" align="stretch">

                <Grid.Col sm ={12} md={6}>

                  <Paragraph>
                  {t("MobilitaetPage.campuspara_1")}<b>ETH eLink</b>{t("MobilitaetPage.campuspara_2")}
                  </Paragraph>

                </Grid.Col>
                        
                <Grid.Col sm ={12} md={6}>

                  <div>
                  <Image
                      maw = {480}
                      mx="auto"
                      radius="md"
                      src={link}
                      caption={t("OrientierungPage.campuscaptionlink")}
                      alt={t("OrientierungPage.campusaltlink")}
                    />
                  </div>
                        
                </Grid.Col>
              </Grid>

              <h2>{t("MobilitaetPage.fahrraedertitle")}</h2>
              
              <Paragraph>
              {t("MobilitaetPage.fahrraederpara_1")}<b>Publibike</b>{t("MobilitaetPage.fahrraederpara_2")}<b>VELOVE</b>{t("MobilitaetPage.fahrraederpara_3")}
              </Paragraph>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                  className={classes.headerbutton}
                  component="a"
                  target="_blank"
                  href={t("MobilitaetPage.fahrraederlink1")}
                  leftIcon={<ExternalLink size={14} />}
                >
                  {t("MobilitaetPage.fahrraederbutton1")}
                </Button>

                <Button
                  className={classes.headerbutton}
                  component="a"
                  target="_blank"
                  href={t("MobilitaetPage.fahrraederlink2")}
                  leftIcon={<ExternalLink size={14} />}
                >
                  {t("MobilitaetPage.fahrraederbutton2")}
                </Button>
              </div>

            </div>

            <div className={classes.content}>

              <h2>{t("MobilitaetPage.oevtitle")}</h2>

              <Paragraph>
              {t("MobilitaetPage.oevpara1_1")}<b>Zürcher Verkehrsverbund (ZVV)</b>{t("MobilitaetPage.oevpara1_2")}<i>NetzPass</i>{t("MobilitaetPage.oevpara1_3")}
              </Paragraph>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap', marginTop: '1rem' }}>
                <Button className={classes.headerbutton} component="a" target="_blank" href={t("MobilitaetPage.oevlink1")} leftIcon={<ExternalLink size={14} />}>
                {t("MobilitaetPage.oevbutton1")}
                </Button>
              </div>

              <Paragraph>
                {t("MobilitaetPage.oevpara2_1")}<b>{t("MobilitaetPage.oevpara2_2")}</b>{t("MobilitaetPage.oevpara2_3")}<i>GA Night</i>{t("MobilitaetPage.oevpara2_4")}
              </Paragraph>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap', marginTop: '1rem' }}>  
                <Button className={classes.headerbutton} component="a" target="_blank" href={t("MobilitaetPage.oevlink2")} leftIcon={<ExternalLink size={14} />}>
                  {t("MobilitaetPage.oevbutton2")}
                </Button>
              </div> 

                  {/*<div>
                    <Image
                      maw = {480}
                      mx="auto"
                      radius="md"
                      src={zug}
                      caption={t("MobilitaetPage.oevcaption")}
                      alt={t("MobilitaetPage.oevalt")}
                    />
                  </div>*/}
            </div>
          </div>
          <div className={classes.container}>

            <h1 className={classes.title}>{t("OrientierungPage.title")}</h1>

            <div className={classes.content}>

              <h2>{t("OrientierungPage.campustitle")}</h2>

              <Paragraph>
              {t("OrientierungPage.campuspara1_1")}<b>Zentrum</b>{t("OrientierungPage.campuspara1_2")}<b>Hönggerberg</b>.
              </Paragraph>

              <Grid grow gutter="lg" justify="space-around" align="stretch">

                <Grid.Col sm ={6} md={4}>
                  <div>
                    <Image
                      maw = {480}
                      mx="auto"
                      radius="md"
                      src={zentrum}
                      caption={t("OrientierungPage.campuscaptionzentrum")}
                      alt={t("OrientierungPage.campusaltzentrum")}
                    />
                  </div>
                </Grid.Col>
                        
                <Grid.Col sm ={6} md={4}>
                  <div>
                    <Image
                      maw = {480}
                      mx="auto"
                      radius="md"
                      src={hoenggerberg}
                      caption={t("OrientierungPage.campuscaptionhoenggerberg")}
                      alt={t("OrientierungPage.campusalthoenggerberg")}
                    />
                  </div>
                </Grid.Col>

              </Grid>

              {/*<Grid grow gutter="lg" justify="space-around" align="stretch">

                <Grid.Col sm ={6} md={4}>
                  <div>
                    <Image
                      maw = {480}
                      mx="auto"
                      radius="md"
                      src={link}
                      caption={t("OrientierungPage.campuscaptionlink")}
                      alt={t("OrientierungPage.campusaltlink")}
                    />
                  </div>
                </Grid.Col>

              </Grid>*/}

              <Paragraph>
              {t("OrientierungPage.campuspara2_1")}<b>ETH eLink</b>{t("OrientierungPage.campuspara2_2")}
              </Paragraph>

              <h2>{t("OrientierungPage.gebaeudetitle")}</h2>
              <Paragraph>
              {t("OrientierungPage.gebaeudepara1")}
              </Paragraph>

              <Paragraph>
              <b>{t("OrientierungPage.gebaeudepara2_1")}</b>{t("OrientierungPage.gebaeudepara2_2")}<b>H</b>{t("OrientierungPage.gebaeudepara2_3")}
              </Paragraph>

              <h2>{t("OrientierungPage.raeumetitle")}</h2>

              <Paragraph>
              {t("OrientierungPage.raeumepara1_1")}<b>E</b> {t("OrientierungPage.raeumepara1_2")}<b>F, G, ...</b> {t("OrientierungPage.raeumepara1_3")}<b>D, C, ...</b>{t("OrientierungPage.raeumepara1_4")}
              </Paragraph>

              <Paragraph>
              {t("OrientierungPage.raeumepara2_1")}<b>HCI J 7</b>{t("OrientierungPage.raeumepara2_2")}<b>HCI</b>{t("OrientierungPage.raeumepara2_3")}<b>J</b>{t("OrientierungPage.raeumepara2_4")}<b>E</b>{t("OrientierungPage.raeumepara2_5")}<b>7</b>{t("OrientierungPage.raeumepara2_6")}
              </Paragraph>

              <h2>{t("OrientierungPage.eduapptitle")}</h2>

              <Paragraph>
              <b>{t("OrientierungPage.eduapppara_1")}</b>{t("OrientierungPage.eduapppara_2")}<b>Campus Map</b>{t("OrientierungPage.eduapppara_3")}
              </Paragraph>
                
            </div>
          </div>
        </SafeAreaContainer>

    </div>
  );
}
